import React from 'react';
import ContentLoader from 'react-content-loader';

const QueueChatLoginLoader = (props) => (
  <ContentLoader
    speed={2}
    width="100%"
    height={124}
    viewBox="0 0 476 124"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
    {...props}
  >
    <rect x="0" y="0" rx="3" ry="3" width="350" height="60" />
    <rect x="355" y="0" rx="3" ry="3" width="150" height="60" />

    <rect x="0" y="65" rx="3" ry="3" width="350" height="60" />
    <rect x="355" y="70" rx="3" ry="3" width="150" height="60" />
  </ContentLoader>
);

export default QueueChatLoginLoader;
